import {v4 as uuidv4} from "uuid"
import MaterialIcon from "material-icons-react"
import {useEffect} from "react";

const Button = (props) => {
    let btnType = props?.type != null ? props.type : "button";
    let btnStyle = props?.style != null ? props.style : {};
    let btnName = props?.name != null ? props.name : "";
    let btnValue = props?.value != null ? props.value : "";
    let btnText = props?.text != null ? props.text : "Submit";
    let btnOnclick = props?.onClick != null ? props.onClick : null;
    let btnClass = props?.class != null ? props.class : "btn";
    let useSpinner = props?.spinner != null ? props.spinner : false;
    let btnId = props?.id != null ? props.id : `btn-${uuidv4()}`;
    let btnDisabled = props?.disabled != null ? props.disabled : false;
    let btnTitle = props?.title != null ? props.title : "";
    let useIcon = props?.icon != null ? props.icon : false;
    let btnIconClass = props?.iconClass != null ? props.iconClass : "";
    let btnIconSize = props?.iconClass != null ? props.iconClass : "small";
    let btnIconColor = props?.iconColor != null ? props.iconColor : "#ffffff";
    let btnIconName = props?.iconName != null ? props.iconName : "";
    let btnIconWeight = props?.bold ? 400 : 200;
    let usePill = props?.pill != null ? props.pill : "";
    let pillColor = props.pillColor != null ? props.pillColor : "bg-info"
    let pillData = props.pillData != null ? props.pillData : "";
    let pill = <></>

    useEffect(() => {
        // Load Material Symbols font
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
        document.head.appendChild(link);

        return () => {
            // Cleanup
            document.head.removeChild(link);
        };
    }, []);

    if (usePill){
        <span className={`position-relative translate-middle badge rounded-pill ${pillColor}`}
              style={{left: "15px"}}>{pillData}</span>
    }

    if (useIcon){
        if (props?.iconType === "google"){
            if (props?.iconPosition === "end"){
                return(
                    <button type={btnType} name={btnName} style={btnStyle} disabled={btnDisabled} className={btnClass}
                            value={btnValue} onClick={btnOnclick} id={btnId} title={props?.title}>
                        {btnText}
                        <MaterialIcon size={btnIconSize} className={btnIconClass} color={btnIconColor}
                                      icon={btnIconName}/>
                        {pill}
                    </button>
                );
            }else{
                return(
                    <button type={btnType} name={btnName} style={btnStyle} disabled={btnDisabled} className={btnClass}
                            value={btnValue} onClick={btnOnclick} id={btnId} title={props?.title}>
                        <MaterialIcon size={btnIconSize} className={btnIconClass} color={btnIconColor}
                                      icon={btnIconName}/>
                        {btnText}
                        {pill}
                    </button>
                );
            }
        }else if (props?.iconType === "google-symbols"){
            if (props?.iconPosition === "end"){
                return(
                    <button type={btnType} name={btnName} style={btnStyle} disabled={btnDisabled} className={btnClass}
                            value={btnValue} onClick={btnOnclick} id={btnId} title={props?.title}>
                        {btnText}
                        <span title={""} className={`material-symbols ${btnIconClass}`}
                            style={{fontVariationSettings: `'FILL' 1, 'wght' ${btnIconWeight}, 'GRAD' 0, 'opsz' 24`,
                                color: btnIconColor,
                                fontFamily: "'Material Symbols'",
                                fontSize: '24px',
                                verticalAlign: 'middle'}}>{btnIconName}</span>
                        {pill}
                    </button>
                );
            }else{
                return(
                    <button type={btnType} name={btnName} style={btnStyle} disabled={btnDisabled} className={btnClass}
                            value={btnValue} onClick={btnOnclick} id={btnId} title={props?.title}>
                        <span title={""} className={`material-symbols ${btnIconClass}`}
                            style={{fontVariationSettings: `'FILL' 1, 'wght' ${btnIconWeight}, 'GRAD' 0, 'opsz' 24`,
                                color: btnIconColor,
                                fontFamily: "'Material Symbols'",
                                fontSize: '24px',
                                verticalAlign: 'middle'}}>{btnIconName}</span>
                        {btnText}
                        {pill}
                    </button>
                );
            }
        }else{
            if (props?.iconPosition === "end"){
                return(
                    <button type={btnType} name={btnName} style={btnStyle} disabled={btnDisabled}
                            className={btnClass} value={btnValue} onClick={btnOnclick} id={btnId}
                            title={props?.title}>
                        {btnText}
                        <i className={btnIconClass}/>
                        {pill}
                    </button>
                );
            }else{
                return(
                    <button type={btnType} name={btnName} style={btnStyle} disabled={btnDisabled}
                            className={btnClass} value={btnValue} onClick={btnOnclick} id={btnId}
                            title={props?.title}>
                        <i className={btnIconClass}/>
                        {btnText}
                        {pill}
                    </button>
                );
            }
        }
    }
    else if (useSpinner){
        return(
            <button type={btnType} style={btnStyle} name={btnName} className={btnClass} value={btnValue}
                    onClick={btnOnclick} id={btnId} disabled={true}>
                <span className={"spinner-border spinner-border-sm"} role={"status"} aria-hidden={true}/> {btnText}
                {pill}
            </button>
        );
    }
    else{
        return(
            <button style={btnStyle} type={btnType} name={btnName} className={btnClass} id={btnId}
                    title={btnTitle} value={btnValue} onClick={btnOnclick} disabled={btnDisabled}>
                {btnText}
                {pill}
            </button>
        );
    }
};

export default Button;